import { Component, OnInit } from '@angular/core';
import { AmbitService } from '../ambit.service';
import * as firebase from 'firebase';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-car-categories',
  templateUrl: './car-categories.component.html',
  styleUrls: ['./car-categories.component.css']
})
export class CarCategoriesComponent implements OnInit {

  public submitted: boolean = false;
  public categoryModel: any = {
    name: '',
    minKmRate: 5,
    maxKmRate: '',
  };
  public loading: boolean = false;
  public categoryCheckedList: any = [];
  public selectAll: boolean = false;

  public searchList: any = ['name'];
  public sortColumn: any = 'name';
  public sortType: boolean = false;

  constructor(public service: AmbitService,
    public toaster: ToastrService,
    public router: Router) {
    if (this.service.adminUser.userAccess.categories == 'None') {
      this.router.navigate(['/home']);
    }
  }

  ngOnInit() {}

  countCars(key) {

    var count = 0;
    if (!this.service.carList.length) {
      return count;
    } else {
      for (var i = 0; i < this.service.carList.length; i++) {
        if (this.service.carList[i].vehicleCategory && this.service.carList[i].vehicleCategory.toLowerCase() == key.toLowerCase()) {
          count++;
        }
      }
      return count;
    }
  }

  toggleSortValue(val) {
    if (this.sortColumn == val) {
      this.sortType = !this.sortType;
    } else {
      this.sortColumn = val;
    }
  }

  onSelectCategory(key, isChecked: boolean) {
    if (key == 'All' && !isChecked) {
      this.selectAll = false;
      this.categoryCheckedList = [];
    } else if (key == 'All' && isChecked) {
      this.selectAll = true;
      this.categoryCheckedList = [];
      for (var i = 0; i < this.service.categoryList.length; i++) {
        this.categoryCheckedList.push(this.service.categoryList[i].key);
      }
    } else {
      if (isChecked) {
        this.categoryCheckedList.push(key);
        if (this.categoryCheckedList.length == this.service.categoryList.length) {
          this.selectAll = true;
        }
      } else {
        this.categoryCheckedList.splice(this.categoryCheckedList.indexOf(key), 1);
        if (!this.categoryCheckedList.length || this.categoryCheckedList.length != this.service.categoryList.length) {
          this.selectAll = false;
        }

      }
    }
  }

  addNewCategory(key) {

    var self = this, formData:any = {}, updates = {};
    self.loading = true;
    formData = {
      name: this.categoryModel.name,
      minKmRate: this.categoryModel.minKmRate,
      maxKmRate: this.categoryModel.minKmRate,
    };

    if(!key) {
      formData.active = true;
      formData.timeStamp =  firebase.database.ServerValue.TIMESTAMP;
      formData.key = firebase.database().ref().child('VehicleCategory/').push().key;
    } else {
      formData.key = key;
    }

    updates['/VehicleCategory/' + formData.key] = formData;
    firebase.database().ref().update(updates).then(() => {
     
      if(!key) { self.service.categoryList.unshift(formData); }
      else { 
        var idx = self.service.categoryList.findIndex(ob => ob['key'] == key);
        if (idx >= 0) {
          self.service.categoryList[idx].name = formData['name'];
          self.service.categoryList[idx].maxKmRate = formData['maxKmRate'];
          self.service.categoryList[idx].minKmRate = formData['minKmRate'];
        }
      }
      self.toaster.success('Vehicle Category data added/updated successfully.','',{timeOut: 3500});
      self.categoryModel = { name: '', minKmRate: 5, maxKmRate: ''};
      document.getElementById('addCategoryMd').click();
      self.loading = false;
     
    }).catch((err) => {
      self.loading = false;
      self.toaster.error(err.message,'',{timeOut:3500});
    });

  }

  updateCategory(key) {
    var self = this;
    var index = self.service.categoryList.findIndex(ob => ob['key'] == key);
    if (index >= 0) {
      var formData: any = { active: self.service.categoryList[index].active ? false:true }
      firebase.database().ref('VehicleCategory/' + key).update(formData).then(() => {
          self.service.categoryList[index].active = formData['active'];
          document.getElementById('closeStatusMd').click();
          self.toaster.success('Vehicle Category status updated successfully.','',{timeOut: 3500});
      }).catch((err) => {
        self.loading = false;
        self.toaster.error(err.message,'',{timeOut:3500});
      });

    }
  }

  removeCategory() {

    var self = this;
    self.loading = true;

    if (self.categoryCheckedList.length >= 0) {
      firebase.database().ref('VehicleCategory/' + self.categoryCheckedList[0]).remove().then(() => {
        var index = self.service.categoryList.findIndex(x => x.key === self.categoryCheckedList[0]);
        self.service.categoryList.splice(index, 1);
        self.categoryCheckedList.splice(0, 1)
        if (self.categoryCheckedList.length >= 1) {
          self.removeCategory();
        } else {
          self.categoryCheckedList = [];
          self.selectAll = false;
          document.getElementById('delCategoryMd').click();
          self.loading = false;
          self.toaster.success('Selected Vehicle Category/ies removed successfully.','',{timeOut: 3500});
        }
      }).catch((err) => {
        self.loading = false;
        self.toaster.error(err.message,'',{timeOut:3500});
      });
    }

  }

}